
import React, { useState } from "react";
import SimpleBar from 'simplebar-react';
import { useLocation } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBan,
  faBolt,
  faCode,
  faGavel,
  faKey,
  faShieldAlt,
  faSignOutAlt,
  faTachometerAlt,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { Nav, Button, Navbar } from '@themesberg/react-bootstrap';
import { Link } from 'react-router-dom';

import { Routes } from "../routes";
import { useAuth } from "../context/AuthContext";

export default () => {
  const location = useLocation();
  const { logout, tenantId, tenantName } = useAuth();
  const { pathname } = location;
  const [show, setShow] = useState(false);
  const showClass = show ? "show" : "";

  const onCollapse = () => setShow(!show);

  const handleLogout = () => {
    logout();
  };

  const NavItem = (props) => {
    const { title, link, icon } = props;
    const navItemClassName = link === pathname ? "active" : "";

    return (
      <Nav.Item className={navItemClassName} onClick={() => setShow(false)}>
        <Nav.Link as={Link} to={link}>
          <span className="sidebar-icon"><FontAwesomeIcon icon={icon} /> </span>
          <span className="sidebar-text">{title}</span>
        </Nav.Link>
      </Nav.Item>
    );
  };

  return (
    <>
      <Navbar expand={false} collapseOnSelect variant="dark" className="navbar-theme-primary px-4 d-md-none">
        <Navbar.Brand className="me-lg-5" as={Link} to={Routes.Welcome.path}>
          <span className="fw-bold text-white">Flowfence</span>
        </Navbar.Brand>
        <Navbar.Toggle as={Button} aria-controls="main-navbar" onClick={onCollapse}>
          <span className="navbar-toggler-icon" />
        </Navbar.Toggle>
      </Navbar>
      <CSSTransition timeout={300} in={show} classNames="sidebar-transition">
        <SimpleBar className={`collapse ${showClass} sidebar d-md-block bg-primary text-white`}>
          <div className="sidebar-inner px-4 pt-3">
            <div className="user-card d-flex d-md-none align-items-center justify-content-between pb-4">
              <div className="d-block">
                <h6 className="text-white mb-1">{tenantName || 'Workspace'}</h6>
                <small className="text-white-50">{tenantId ? `${tenantId.slice(0, 8)}…` : '—'}</small>
              </div>
              <Nav.Link className="collapse-close d-md-none" onClick={onCollapse}>
                <FontAwesomeIcon icon={faTimes} />
              </Nav.Link>
            </div>
            <Nav className="flex-column pt-3 pt-md-0">
              <Nav.Item className="mb-3">
                <Nav.Link as={Link} to={Routes.Welcome.path} className="fw-bold">
                  Flowfence
                </Nav.Link>
              </Nav.Item>

              <NavItem title="Dashboard" link={Routes.Dashboard.path} icon={faTachometerAlt} />
              <NavItem title="Decision" link={Routes.Decide.path} icon={faGavel} />
              <NavItem title="Rules" link={Routes.Rules.path} icon={faBolt} />
              <NavItem title="Blocklist" link={Routes.Blocklist.path} icon={faBan} />
              <NavItem title="Tokens" link={Routes.Tokens.path} icon={faKey} />
              <NavItem title="Account" link={Routes.Account.path} icon={faShieldAlt} />
              <NavItem title="API docs" link={Routes.Developers.path} icon={faCode} />

              <hr className="sidebar-divider my-3" />
              <Nav.Item>
                <Nav.Link onClick={handleLogout} className="cursor-pointer">
                  <span className="sidebar-icon"><FontAwesomeIcon icon={faSignOutAlt} /> </span>
                  <span className="sidebar-text">Sign out</span>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>
        </SimpleBar>
      </CSSTransition>
    </>
  );
};
